import style from './style.module.css'

const NewsItem = () => {
  return (
    <div className={style.companyModal_news_item}>
      <span className={style.companyModal_news_item_title}>
        New Ray-Ban Meta smart glass styles and Meta AI Updates
      </span>
      <span className={style.companyModal_news_item_text}>
        We're adding new styles, video calli...
      </span>
      <span className={style.companyModal_news_item_date}>April 23, 2024</span>
    </div>
  )
}

export default NewsItem
